module.exports = __webpack_public_path__ + "img/women-autonomy-filled.4343a6e5.svg";